import { render, staticRenderFns } from "./CollaboratorNamePromptModal.vue?vue&type=template&id=7735ce5c"
import script from "./CollaboratorNamePromptModal.vue?vue&type=script&lang=js"
export * from "./CollaboratorNamePromptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports